import React from 'react';
import { useTheme } from '@mui/material/styles';
import { GlassColors } from '../../../components/glassmorphism/GlassmorphismStyles';
import { Box, Skeleton } from '@mui/material';

const SkeletonBlock = ({
  width = '100%',
  height = 16,
  radius = 12,
  style = {},
}: {
  width?: number | string;
  height?: number | string;
  radius?: number;
  style?: React.CSSProperties;
}) => (
  <div
    style={{
      width,
      height,
      borderRadius: radius,
      animation: 'skeleton-loading 1.4s ease infinite',
      ...style,
    }}
  />
);

const SortChipSkeleton = () => (
  <SkeletonBlock
    width={150}
    height={42}
    radius={999}
    style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 8px 24px' }}
  />
);

export const BrowseHandymanSkeleton = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <>
      <style>
        {`
          @keyframes skeleton-loading {
            0% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0 50%;
            }
          }
        `}
      </style>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '320px 1fr' },
          gap: '24px',
          background: isDark
            ? GlassColors.dark.primaryBackground
            : GlassColors.light.primaryBackground,
          minHeight: '100vh',
        }}
      >
        <Box
          component='aside'
          sx={{
            background: isDark
              ? GlassColors.dark.primaryBackground
              : GlassColors.light.primaryBackground,
            padding: '20px',
            boxShadow: '0 10px 24px rgba(0,0,0,0.12)',
            alignSelf: 'start',
            display: { xs: 'none', md: 'block' },
            borderRadius: '32px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: '16px',
              gap: '24px',
              borderRadius: '32px',
              width: '100%',
            }}
          >
            {/* Title */}
            <Skeleton
              variant='text'
              width={140}
              height={32}
              sx={{ borderRadius: '8px' }}
            />

            {/* Search */}
            <Skeleton
              variant='rounded'
              width='100%'
              height={48}
              sx={{ borderRadius: '999px' }}
            />

            {/* Categories list */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                width: '100%',
              }}
            >
              {Array.from({ length: 4 }).map((_, i) => (
                <Box
                  key={i}
                  sx={{
                    width: '100%',
                    padding: '8px 15px 8px 24px',
                    borderRadius: '32px',
                  }}
                >
                  {/* Row skeleton  */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <Skeleton variant='circular' width={32} height={32} />
                    <Skeleton variant='text' width='60%' height={24} />
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <main>
          <div
            style={{
              display: 'flex',
              gap: 14,
              flexWrap: 'wrap',
              marginBottom: 20,
            }}
          >
            {Array.from({ length: 4 }).map((_, i) => (
              <SortChipSkeleton key={i} />
            ))}
          </div>

          <div style={{ display: 'grid', gap: 20 }}>
            {Array.from({ length: 3 }).map((_, i) => (
              <SkeletonBlock
                key={i}
                style={{
                  background: isDark
                    ? GlassColors.dark.primaryBackground
                    : GlassColors.light.primaryBackground,
                  borderRadius: 28,
                  height: '90px',

                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                }}
              />
            ))}
          </div>
        </main>
      </Box>
    </>
  );
};

export default BrowseHandymanSkeleton;
